import { trackDecoratorWithExtendedLabel } from './mainTrackers';

export const sendAnalyticPrintableWorkoutDownload = () => {
    trackDecoratorWithExtendedLabel('printable_pdf__download__click');
};
